/* Organic Cecret small front-end fixes */
(function () {
  function cleanIntro() {
    var title = document.querySelector('.tlp__title');
    var desc = document.querySelector('.tlp__desc');
    if (!title || !desc) return;
    var walker = document.createTreeWalker(desc, NodeFilter.SHOW_TEXT);
    var node = walker.nextNode();
    while (node && !node.nodeValue.trim()) node = walker.nextNode();
    if (!node) return;
    var t = node.nodeValue.replace(/^\s+/, '');
    if (t.indexOf('ORGANIC CECRET') !== 0) return;
    t = t.slice('ORGANIC CECRET'.length).replace(/^\s+/, '');
    var name = title.textContent.trim();
    if (name && t.toUpperCase().indexOf(name.toUpperCase()) === 0) t = t.slice(name.length).replace(/^[\s:\-–—]+/, '');
    node.nodeValue = t;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cleanIntro);
  else cleanIntro();
})();
